module.exports = __webpack_public_path__ + "img/projects1.740a6604.png";